import { styled } from "@mui/system";

/** A styled link to external pages. Use it to redirect to another domain or application */
export const ExternalTextLink = styled("a")(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 500,
  textDecoration: "underline",
}));
